import React from 'react'
import { useTranslation } from 'react-i18next';

const Payments = () => {
    const { t } = useTranslation();
    return (
        <div className='w-full h-screen flex items-center justify-center'>
            <p className='flex text-[30px] text-gray-400 dark:text-white text-center'>
                {t("userProfile.comingSoon")}
            </p>
        </div>
    )
}

export default Payments